export default "__VITE_ASSET__0c39c5d4__"